import { ReactNode, useEffect, useState } from "react";
import { IRenter } from "../../../../types/renter.type";
import { getRenterById, updateRenter } from "../../../../common/services/renters.api";
import { initialState, RenterDashboardContext } from "./RenterDashboard.context";

type Props = {
  children: ReactNode,
  renterId: string
}

export function RenterDashboardProvider(props: Props) {

  const [renter, setRenter] = useState<IRenter>(initialState.renter)

  useEffect(() => {
    async function loadRenter(renterId: string) {
      const result = await getRenterById(renterId)

      if (result.ok) {
        setRenter(result.data as IRenter)
      }
    }

    loadRenter(props.renterId)
  }, [props.renterId])

  async function saveRenter(dataToSave: IRenter) {
    try {
      const { ok, data, errors } = await updateRenter(renter._id as string, dataToSave)

      if (ok && data) {
        setRenter(data as IRenter)
        return { ok, data: data as IRenter, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: data as IRenter, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      console.log(err)

      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { renter, saveRenter }

  return (
    <RenterDashboardContext.Provider value={theState}>
      {props.children}
    </RenterDashboardContext.Provider>
  )
}